import React, { useEffect, useState } from 'react';
import Typography from "@material-ui/core/Typography";
import { Button } from "@material-ui/core";
import { themeButtons } from "../../../css/themeButtons";
import Box from "@material-ui/core/Box";
import { confirmMessageWithType } from "../../UserSettings/UserSettings";


const FastVerified = (props) => {

  const { goPage, history, sendUserConfirmation, email, personalMobile, messenger, login, stage } = props

  const [confirmMessage, setConfirmMassage] = useState()
  const [requestTimeout, setRequestTimeout] = useState(null)

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [])

  const backToObjectsList = () => {
    history.replace("/lk")
  }

  const goNextPage = () => {
    goPage(stage)
  }


  const confirmContact = async (type) => {
    if (type) {
      setConfirmMassage(confirmMessageWithType[type])
      sendUserConfirmation({ type })

      if (!requestTimeout) {
        setRequestTimeout(60)
      }

    }
  }

  useEffect(() => {
    let timer = null

    if (requestTimeout) {
      timer = setTimeout(() => {
        setRequestTimeout(prev => prev - 1);
      }, 1000);
    } else {
      setRequestTimeout(null)
    }

    return () => clearTimeout(timer);

  }, [requestTimeout]);

  let verificationText = '';
  if (login && login.indexOf('@') >= 0) {
    verificationText = <>
      Вы ещё не подтвердили вашу регистрацию. Мы отправили вам ссылку для подтверждения аккаунта на <b>{login}</b>.
      Перейдите по ссылке из письма или отправьте запрос на подтверждение повторно
    </>;
  } else {
    verificationText = <>
      Вы ещё не подтвердили вашу регистрацию. Мы отправили вам ссылку для подтверждения аккаунта на
      номер <b>{login}, {messenger}</b>.<br/>
      Перейдите по ссылке из сообщения.<br/>
      Если вы потеряли ссылку, отправьте запрос на ее получение повторно (кнопка ниже)
    </>;
  }

  const buttons = themeButtons()
  return (
    <div className="stepByStepWrp">
      <div className="stepByStepWrp__header">
        <Typography variant="h5" component="h5" className="stepByStepWrp__title">Подтверждение
          регистрации</Typography>
      </div>
      <div className="stepByStepWrp__body">
        {confirmMessage &&
          <Box className="alert alert-success mb-3">
            {confirmMessage}
          </Box>
        }

        <Box className="d-flex flex-column mb-3 stepByStepWrp__verification-box">
          <Typography component="p" className="mb-3">{verificationText}</Typography>
          {personalMobile && <Box className="mb-2 d-flex align-items-center flex-md-row flex-column">
            <span className="stepByStepWrp__verification-box__value">{personalMobile}</span>
            <Button onClick={() => confirmContact(messenger)}
                    disabled={Boolean(requestTimeout)}
                    className={`btn ${buttons.btnGreen} ms-2 stepByStepWrp__verification-box__btn`}>
              Получить ссылку на {messenger}
            </Button>
          </Box>}
          {email && <Box className="d-flex align-items-center flex-md-row flex-column">
            <span className="stepByStepWrp__verification-box__value">{email}</span>
            <Button onClick={() => confirmContact("email")}
                    disabled={Boolean(requestTimeout)}
                    className={`btn ${buttons.btnGreen} ms-2 stepByStepWrp__verification-box__btn`}>
              Получить ссылку на E-mail
            </Button>
          </Box>}


        </Box>


        {requestTimeout && <p className="small text-muted">Повторно запросить ссылку можно через
          00:00:{requestTimeout >= 10 ? requestTimeout : `0${requestTimeout}`}</p>}
      </div>


      <div className="stepByStepWrp__actions">
        <Button className={`btn`} onClick={backToObjectsList}>Назад к объектам</Button>
        <Button className={`btn ${buttons.btnGreen}`}
                onClick={goNextPage}>Пока пропустить</Button>
      </div>
    </div>


  )
}


export default FastVerified;
